import React, { FC, useEffect, useState } from "react";
import { Row, Col, Image, Spin, Card, Select, Tooltip } from "antd";
import styled from "styled-components";
import { GET_ALL_DESIGNS } from "../../Apollo/graphql/Query/getDesigns";
import { useLazyQuery } from "@apollo/client";
import { Button3D } from "../../Components/Button3D";
import FooterPublic3D from "../../Components/FooterPublic3D";
import SearchIcon from "../../assets/images/searchIcon.png";
import HeaderComponent from "../../Components/HeaderComponents";
import { Link } from "react-router-dom";
import { CommentOutlined } from "@ant-design/icons";
// import Img3D from "../../Components/Model3D";
import InfiniteScroll from "react-infinite-scroll-component";
import LikeDesign from "../../Components/LikeDesign";
import { getUserData, fallBackImage } from "../../utils/utilsFunctions";
import { Input3D } from "../../Components/Input3D";
import NullDataComp from "../../Components/NullDataComp";
import { CloudDownloadOutlined } from '@ant-design/icons';

const { Option } = Select;

const MainWrapper = styled.div`
  background: #f7f7f7;
  display: flex;
  flex:1;
  flex-direction: column;
  justify-content: center;
`;
const SubHeader = styled.div`
  width: 100%;
  display: flex;
  flex-flow: row;
  padding: 5px;
  justify-content: space-between;
  margin-top: 10px;
  background: white;
  box-shadow: 0 5px 5px rgba(182, 182, 182, 0.75);

  .ant-select-selector{
    border: none !important;
  }

  .small-text{
    font-size: 10px;
    font-weight: 700;
  }
`
const ContentDivX = styled(Col)`
  display: flex;
  justify-content: center;
  margin-top: 2rem;
`;

const IconBox = styled(Image)`
  height: 20px;
  width: 20px;
  margin-right: 10px;
`;
const StatsDiv = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
`;
const SingleStatWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  cursor: pointer;
  margin-right: 8px;
`;

const CardX = styled(Card)`
  display: flex;
  flex-direction: column;
  box-shadow: 0px 0px 8px rgba(0, 0, 0, 0.08);
  cursor: pointer;
  .ant-card-cover {
    height: 250px;
    justify-content: center;
    align-items: center;
    overflow: hidden;
    display: flex;
    .ant-image {
      height: 100%;
      text-align: center;
    }
  }
  .ant-card-body {
    padding: 1rem;
  }
`;

const Img = styled(Image)`
display: inline-block;
width: auto;
max-width: 100%;
height: 100%;
object-fit: contain;
/* max-inline-size: 100%;
block-size: auto;
aspect-ratio: 2/1;
object-fit: cover;   */
`
// const Img = styled.img`
//   display: inline-block;
//   width: inherit;
//   max-width: 100%;
// `;
const InfoDiv = styled.div`
  display: flex;
  flex-direction: column;
  .info-text-title {
    text-transform: capitalize;
    font-size: 1rem;
    color: #000;
    font-weight: 700;
  }
  .design-info {
    display: flex;
    flex-flow: row;
    justify-content: space-between;
  }
  .info-text {
    text-transform: capitalize;
  }
`;

const AnchorComp = styled(Link)`
  display: block;
  text-decoration: none;
  color: #000;
  &:hover {
    color: #000;
  }
`;
// const image3dStyle = {
//   top: 0,
//   right: 0,
//   alignItems: 'center',
//   height: '250px',
//   width: '100%'
// }

const Marketplace: FC = () => {
  // const [designs, setDesigns] = useState([]);
  const [loadedDesigns, setLoadedDesigns] = useState<any>([]);
  const [searchValue, setSearchValue] = useState<any>();
  const [sortValue, setSortValue] = useState<any>("popular");
  const [filterValue, setFilterValue] = useState<any>('All');
  // const [currentPage, setCurrentPage] = useState<any>(1);
  const [totalDesigns, setTotalDesigns] = useState<any>(null);
  const [queryVariables, setQueryVariables] = useState<any>({});
  const PAGE_LIMIT = 20;

  const user = JSON.parse(getUserData("user"));

  const [getDesigns, { loading }] = useLazyQuery(GET_ALL_DESIGNS, {
    fetchPolicy: 'network-only',
    onCompleted: (data) => {
      if(data?.designs?.pagination?.page === 1){
        setLoadedDesigns([...data?.designs?.designs])
      } else {
        setLoadedDesigns([...loadedDesigns, ...data?.designs?.designs]);
      }
      setTotalDesigns(data?.designs?.pagination?.total)
    },
    onError: (err) => {
      console.log(err);
    },
  });

  const loadDesigns = (variables) => {
    getDesigns({
      variables
    })
  }

  useEffect(() => {
    const variables = {};
    variables['pagination'] = {
      page: 1,
      limit: PAGE_LIMIT
    }
    if(filterValue.toLowerCase() !== 'all'){
      variables['filter'] ={
        marketPlaceType: filterValue
      }
    }
    if (searchValue && searchValue.length > 0) {
      variables["filter"] = {
          ...variables["filter"],
          search: searchValue
      }
  }
    if(sortValue === 'asc' || sortValue === 'desc'){
      variables['sort'] = {
        price: sortValue
      }
    }
    if(sortValue === 'popular'){
      variables['sort'] = {
        popularity: 'desc'
      }
    }
    setQueryVariables({...variables});
    loadDesigns({ ...variables})

  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [sortValue, filterValue])

  const handleFilterClick = () => {
    const variables = {};
    variables['pagination'] = {
      page: 1,
      limit: PAGE_LIMIT
    }
    if(filterValue.toLowerCase() !== 'all'){
      variables['filter'] ={
        marketPlaceType: filterValue
      }
    }
    if (searchValue && searchValue.length > 0) {
      variables["filter"] = {
          ...variables["filter"],
          search: searchValue
      }
  }
    if(sortValue === 'asc' || sortValue === 'desc'){
      variables['sort'] = {
        price: sortValue
      }
    }
    if(sortValue === 'popular'){
      variables['sort'] = {
        popularity: 'desc'
      }
    }
    setQueryVariables({...variables});
    loadDesigns({ ...variables})
  };


  const loadMore = () => {
    if(!totalDesigns){
      return;
    }
    if(loadedDesigns.length < totalDesigns){
      const variables = { ...queryVariables };
      variables.pagination.page = queryVariables.pagination.page + 1;
      loadDesigns({ ...variables })
    }
  };

  // const preview3dModal = (design) => (
  //   <div style={{ padding: "1rem" }}>
  //     <Img3D url={design?.design} style={image3dStyle} />
  //   </div>
  // );

  return (
    <Spin spinning={loading && loadedDesigns.length === 0}>
      <MainWrapper>
        <HeaderComponent bg="white" />
        <Col span={20} offset={2}>
          <ContentDivX>
            <Input3D
            onChange={(e) => setSearchValue(e.target.value)}
            prefix={<IconBox src={SearchIcon} alt="" />} />
            <Button3D
              type="primary"
              style={{
                height: "50px",
                width: "6.25rem",
                color: "white",
                marginLeft: "10px",
              }}
              onClick={handleFilterClick}
            >
              Search
            </Button3D>
          </ContentDivX>
          {/* <hr /> */}
          <SubHeader>
            <div>
              <div style={{ display: 'flex', flexDirection: 'column' }}>
                <div className="small-text">MARKET PLACE TYPE</div>
                <div>
                  <Select
                    // placeholder="SelectX"
                    onChange={(e) => setFilterValue(e)}
                    // onSelect={onSelectClick}
                    dropdownMatchSelectWidth={false}
                    // style={{width: '100px'}}
                    defaultValue="ALL"
                  >
                    <Option value="All">All</Option>
                    <Option value="FREE">Free</Option>
                    <Option value="PAID">Paid</Option>
                  </Select>
                </div>
              </div>
            </div>
            <div style={{ display: 'flex', flexDirection: 'column' }}>
              <div className="small-text">SORT BY</div>
              <div>
                <Select
                  // placeholder="Select the recent"
                  onChange={(e) => setSortValue(e)}
                  defaultValue="Popular"
                  // style={{width: '150px'}}
                  dropdownMatchSelectWidth={false}
                // onSelect={onSelectSort}
                >
                  <Option value="popular">Popular</Option>
                  <Option value="recent">Recent</Option>
                  <Option value="desc">Price - High to Low</Option>
                  <Option value="asc">Price - Low to High</Option>
                </Select>
              </div>
            </div>
          </SubHeader>
          <InfiniteScroll
            dataLength={loadedDesigns.length}
            next={loadMore}
            hasMore={true}
            loader={<h4 style={{ textAlign: 'center', marginTop: '1rem' }}>Loading...</h4>}
            style={{ margin: "2rem 0", overflow: "unset" }}
            scrollableTarget="scrollableDiv"
          >
            <Row gutter={[32, 32]}>
              {loadedDesigns?.length === 0 && <NullDataComp />}
              {loadedDesigns &&
                loadedDesigns.map((design: any, i) => {
                  return (
                    <Col
                      xl={{ span: 6 }}
                      md={{ span: 12 }}
                      sm={{ span: 24 }}
                      xs={{ span: 24 }}
                      key={design._id}
                    >
                      {/* <Popover content={() => preview3dModal(design)}> */}
                        <AnchorComp to={`/design/${design._id}`}>
                          <CardX
                            loading={false}
                            cover={
                              <Img
                                alt={design.name}
                                src={design.featuredImage || fallBackImage}
                                fallback={fallBackImage}
                                preview={false}
                              />
                            }
                          >
                            <InfoDiv>
                              <div>
                                <strong className="info-text-title">
                                  {design?.name}
                                </strong>
                              </div>
                              <div style={{ fontWeight: 500 }}>{design.marketPlaceType === "PAID" ? `$${design?.price}` : design.marketPlaceType}</div>
                              <div className="design-info">
                                <div>
                                  by{" "}
                                  <span className="info-text">
                                    {" "}
                                    {design?.owner?.firstName}{" "}
                                  </span>
                                </div>
                                <StatsDiv>
                                  <SingleStatWrapper>
                                  <LikeDesign design={design} user={user} />
                                  </SingleStatWrapper>
                                  <Tooltip placement="bottom" title={"Downloads"}>
                                  <SingleStatWrapper>
                                    <CloudDownloadOutlined style={{ marginRight: 2 }} />
                                    <div style={{fontWeight: 600, color: '#3d3d4e'}}>
                                      {design?.downloadsCount || 0}
                                    </div>
                                  </SingleStatWrapper>
                                  </Tooltip>
                                </StatsDiv>
                                
                              </div>
                              <hr
                                style={{
                                  width: "100%",
                                  border: "1px solid #D8D8D8",
                                }}
                              />
                              <div
                                style={{
                                  display: "flex",
                                }}
                              >
                                <CommentOutlined
                                  style={{
                                    fontSize: "1.2rem",
                                    marginRight: 10,
                                  }}
                                />
                                {design.commentCount || ""}
                                <span style={{ marginLeft: 5 }}>Comments</span>
                              </div>
                            </InfoDiv>
                          </CardX>
                        </AnchorComp>
                      {/* </Popover> */}
                    </Col>
                  );
                })}
            </Row>
          </InfiniteScroll>
        </Col>
        <FooterPublic3D />
      </MainWrapper>
    </Spin>
  );
};
export default Marketplace;
